import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var PlazoComponent = /** @class */ (function () {
    function PlazoComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            plazo: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("plazo"))) {
            localStorage.setItem("plazo", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("plazo"));
            this.form.controls['plazo'].setValue(this.rows[0] ? this.rows[0].plazo : '');
        }
        // this.plazo = { plazo:0};
    }
    PlazoComponent.prototype.add_plazo = function () {
        localStorage.setItem("plazo", JSON.stringify([]));
        this.actualRow = localStorage.getItem("plazo");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            plazo: this.form.value.plazo
        });
        localStorage.setItem("plazo", JSON.stringify(this.rows));
        //this.form.reset();//
    };
    PlazoComponent.prototype.delete_plazo = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("plazo", JSON.stringify(this.rows));
            }
        }
    };
    return PlazoComponent;
}());
export { PlazoComponent };
